import ROUTES from '../../enums/routes';

// eslint-disable-next-line no-unused-vars
export default function getHospitalNavigation(store) {
  return [
    {
      icon: 'people',
      title: 'Users',
      route: ROUTES.USERS,
    },
    {
      icon: 'content_paste',
      title: 'Incidents',
      route: ROUTES.HOSPITAL_INCIDENTS,
    },
    {
      icon: 'mdi-format-list-bulleted',
      title: 'Log',
      route: ROUTES.HOSPITAL_INCIDENTS_LOG,
    },
    {
      icon: 'mdi-hospital-building',
      title: 'My Hospital',
      route: ROUTES.MY_HOSPITAL,
    },
  ];
}
